import './Card.scss';

import React, { ReactNode } from 'react';

import { cn } from '@/src/util/ui';

type CardProps = React.HTMLProps<HTMLDivElement> & {
  children: ReactNode;
  cardRef?: React.RefObject<HTMLDivElement>;
  className: string;
  id?: string;
  onClick?: (event: React.KeyboardEvent<HTMLDivElement> | React.MouseEvent<HTMLDivElement>) => void;
};

const Card = ({
  children,
  className,
  onClick = null,
  cardRef = null,
  ...otherProps
}: CardProps) => {
  if (onClick) {
    return (
      <div
        ref={cardRef}
        className={cn(
          'card--container',
          'tw-bg-white',
          className,
          'tw-w-[100%]',
          'tw-cursor-pointer'
        )}
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={onClick}
        {...otherProps}
      >
        {children}
      </div>
    );
  }

  return (
    <div ref={cardRef} className={cn('card--container tw-bg-white', className)} {...otherProps}>
      {children}
    </div>
  );
};

export default Card;
